
namespace TabAurous.Stock {

    @Serenity.Decorators.registerClass()
    export class JobTransactionGrid extends Serenity.EntityGrid<JobTransactionRow, any> {
        protected getColumnsKey() { return 'Stock.JobTransaction'; } 
        protected getIdProperty() { return JobTransactionRow.idProperty; }
        protected getInsertPermission() { return JobTransactionRow.insertPermission; }
        protected getLocalTextPrefix() { return JobTransactionRow.localTextPrefix; }
        protected getService() { return JobTransactionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}